import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem } from '@/utils';
import { CertType } from '@/constants/global';

const { name, bem } = createNamespaceBem('user-card');

const userCardProps = {
  avatar: String,
  name: String,
  relation: String,
  gender: String,
  age: Number,
  idcard: String,
  certType: Number,
};

export type UserCardProps = ExtractPropTypes<typeof userCardProps>;

export default defineComponent({
  name,
  props: userCardProps,
  setup(props) {
    const renderAvatar = () => {
      return (
        <div class={bem('avatar')}>
          <img src={props.avatar} alt="avatar" />
        </div>
      );
    };

    const renderInfo = () => {
      return (
        <div class={bem('info')}>
          <div class="name">
            <span>{props.name}</span>
            <span class="tag">{props.relation}</span>
          </div>
          <div class="gender">
            <span>{props.gender}</span>
            <span class="point"></span>
            {Number(props.age) > -1 && <span class="age">{Number(props.age)}岁</span>}
          </div>
          {props.idcard && (
            <div class="idcard">
              <div class="type">{CertType.find((cert) => cert.value === props.certType)?.text}</div>
              <div class="numb">{props.idcard}</div>
            </div>
          )}
        </div>
      );
    };

    return () => (
      <div class={bem()}>
        <div class={bem('wrap')}>
          {/* 当有传头像时，才展示头像 */}
          {props.avatar && renderAvatar()}
          {renderInfo()}
        </div>
        <div class={bem('bg')}></div>
        <div class={bem('mask')}></div>
      </div>
    );
  },
});
